import { render, staticRenderFns } from "./SessionOrdersWindow.vue?vue&type=template&id=02827352&scoped=true&"
import script from "./SessionOrdersWindow.vue?vue&type=script&lang=ts&"
export * from "./SessionOrdersWindow.vue?vue&type=script&lang=ts&"
import style0 from "./SessionOrdersWindow.vue?vue&type=style&index=0&id=02827352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02827352",
  null
  
)

export default component.exports